import { computed, inject, Injectable, Signal } from '@angular/core';
import { CorporateDesignStore } from '../api/corporate-design/corporate-design-store.service';
import { DarkModeStore } from '../api/dark-mode/dark-mode-store.service';
import { ICorporateDesign } from '@web/dtos';

@Injectable({
  providedIn: 'root',
})
export class MockCorporateDesignService {
  private darkModeStore: DarkModeStore = inject(DarkModeStore);
  private corporateDesignStore: CorporateDesignStore =
    inject(CorporateDesignStore);

  corporateDesign: Signal<ICorporateDesign> = computed(() => {
    return this.corporateDesignStore.corporateDesign();
  });

  isCorporateDesignLoading(): boolean {
    return this.corporateDesignStore.isLoading();
  }

  isShopContext(): boolean {
    return true;
  }

  isCmsContext(): boolean {
    return false;
  }

  isDarkModeActive(): boolean {
    return this.darkModeStore.isActive();
  }

  darkFontColor(lightMode: string): string {
    if (this.darkModeStore.isActive()) {
      return this.corporateDesignStore.corporateDesign().primaryDarkFontColor;
    }
    return lightMode;
  }

  secondaryDarkFontColor(lightMode: string): string {
    if (this.darkModeStore.isActive()) {
      return this.corporateDesign().colorAdmixtures.dark_text;
    }
    return lightMode;
  }

  primaryColor(): string {
    if (this.isDarkModeActive()) {
      return this.corporateDesign().primaryDarkColor;
    }
    return this.corporateDesign().primaryColor;
  }

  primaryFontColor(): string {
    if (this.darkModeStore.isActive()) {
      return this.corporateDesign().primaryDarkFontColor;
    }
    return this.corporateDesign().primaryFontColor;
  }

  primaryBorderColor(): string {
    return this.corporateDesign().primaryBorderColor;
  }

  linkIconColor(): string {
    if (this.darkModeStore.isActive()) {
      return this.corporateDesignStore.corporateDesign().linkIconDark;
    }
    return this.corporateDesignStore.corporateDesign().linkIcon;
  }
}
